import AnswerCard from "@/components/train/AnswerCard";
import QuestionRenderPage from "@/components/train/QuestionRenderPage";
import api from "@/api";
import subjects from "@/utils/subjects";
import WatermarkerView from "@/components/WatermarkerView";
import DigitSymbolReactionSession from "@/components/subject/DigitSymbolReaction/DigitSymbolReactionSession.vue";
export default {
  name: "TrainAnswerView",
  components: {
    QuestionRenderPage,
    AnswerCard,
    WatermarkerView,
    DigitSymbolReactionSession
  },
  data() {
    return {
      current: 0,
      subject: this.$route.params.subject,
      examId: this.$route.params.examId,
      roomId: this.$route.query.roomId,
      tplId: this.$route.query.tplId,
      session: null,
      answerStarted: false,
      circuitRoutingIntroductionVisible: false,
      circuitRoutingIntroductionSubmitting: false
    };
  },
  methods: {
    ansTypeMap() {
      return subjects.ansTypeMap[this.subject];
    },
    ansModeMap() {
      return subjects.ansModeMap[this.subject];
    },
    init() {
      // if(subject === 'GraphMemory') {

      // }
      api.queryCurrentQuestion(this.examId).then(ret => {
        if (ret.historyMark) {
          this.$router.replace({
            name: 'ReviewAnswerView',
            params: {
              subject: ret.subject,
              examId: ret.examId
            },
            query: {
              roomId: this.roomId,
              tplId: this.tplId
            }
          });
          return;
        }
        this.current = ret.current;
        this.session = ret;
        if (this.subject === 'CircuitRouting' && ret.circuitRoutingIntroductionAcknowledged === false) {
          this.circuitRoutingIntroductionVisible = true;
          return;
        }
        this.answerStarted = true;
      }).catch(e => {
        console.log(e);
        this.$router.replace('/');
      });
    },
    onTimeUp() {
      this.$refs.questionRender.onTimeUp();
    },
    acknowledgeCircuitRoutingIntroduction() {
      this.circuitRoutingIntroductionSubmitting = true;
      api.acknowledgeCircuitRoutingIntroduction(this.examId).then(ret => {
        this.current = ret.current;
        this.session = ret;
        this.circuitRoutingIntroductionVisible = false;
        this.answerStarted = true;
      }).finally(() => {
        this.circuitRoutingIntroductionSubmitting = false;
      });
    }
  },
  mounted() {
    this.init();
  }
};